<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M10.8566 1.71436H12.5709C12.874 1.71436 13.1647 1.83477 13.379 2.04909C13.5933 2.26342 13.7137 2.5541 13.7137 2.85721V14.2858C13.7137 14.5889 13.5933 14.8796 13.379 15.0939C13.1647 15.3082 12.874 15.4286 12.5709 15.4286H3.42801C3.1249 15.4286 2.83422 15.3082 2.61989 15.0939C2.40557 14.8796 2.28516 14.5889 2.28516 14.2858V2.85721C2.28516 2.5541 2.40557 2.26342 2.61989 2.04909C2.83422 1.83477 3.1249 1.71436 3.42801 1.71436H5.1423"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.71401 0.571289H6.28544C5.65426 0.571289 5.14258 1.08296 5.14258 1.71415V2.28557C5.14258 2.91675 5.65426 3.42843 6.28544 3.42843H9.71401C10.3452 3.42843 10.8569 2.91675 10.8569 2.28557V1.71415C10.8569 1.08296 10.3452 0.571289 9.71401 0.571289Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.62305 7.08922C4.62305 7.8782 5.26264 8.51779 6.05162 8.51779C6.25107 8.51779 6.44099 8.47692 6.61342 8.40308C7.1231 8.18486 7.48019 7.67875 7.48019 7.08922C7.48019 6.30024 6.84059 5.66064 6.05162 5.66064C5.26264 5.66064 4.62305 6.30024 4.62305 7.08922Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.51562 10.0942L11.3728 12.9514"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.3747 10.0942L8.51758 12.9514"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
